module.exports = "/wp-content/themes/aly-2-markkinointisaitti/static/images/arrow-dark.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons/arrow-dark.svg
// module id = 21
// module chunks = 2